
import { inject, Injectable } from "@angular/core";
import { State, Action, StateContext } from "@ngxs/store";
import { OnGetJets, OnAddJets, OnRemoveJets, OnGetNotesGridData, OnAddNewNote } from "./example.actions";
import { ExampleStateModel } from "./example.model";
import { ExampleService } from "../example.service";
import { tap } from "rxjs/operators";
import { OnSetSharedGridRowData, OnRemoveSharedGridRowData } from "app/modules/shared/ag-grid/shared-grid-state/shared-grid.actions";

const DEFAULT_EXAMPLE_STATE: ExampleStateModel = {
    jets: []
};

@State<ExampleStateModel>({
    name: 'exampleState',
    defaults: DEFAULT_EXAMPLE_STATE,
})

@Injectable()
export class ExampleState {

    private _exampleService = inject(ExampleService);

    //** Gets the jets from the service and sets the grid row data */
    @Action(OnGetJets)
    onGetJets(ctx: StateContext<ExampleStateModel>, { payload }: OnGetJets) {
        return this._exampleService.getJetPlanes().pipe(
            tap((response: []) => {
                //!! this is a shared grid action that is used to set the grid row data, for the main grid
                ctx.dispatch(new OnSetSharedGridRowData({ reload: true, payload: response, gridUUID: payload.gridUUID }));
            })
        );
    }

    //** Example on how we could add a single jets to the grid */
    @Action(OnAddJets)
    onAddJets(ctx: StateContext<ExampleStateModel>, { payload }: OnAddJets) {
        ctx.dispatch(new OnSetSharedGridRowData({ payload: payload.jets, gridUUID: payload.gridUUID }));
    }

    @Action(OnRemoveJets)
    onRemoveJets(ctx: StateContext<ExampleStateModel>, { payload }: OnRemoveJets) {
        ctx.dispatch(new OnRemoveSharedGridRowData({ removeRow: payload.removeRow, gridUUID: payload.gridUUID }));
    }

    @Action(OnGetNotesGridData)
    onGetNotesGridData(ctx: StateContext<ExampleStateModel>, { payload }: OnGetNotesGridData) {
        return this._exampleService.getFilteredNotes(
            {
                queryType: 'and',
                documentId: payload._id
            }
        ).pipe(
            tap((response: []) => {
                //!! this is a shared grid action that is used to set the grid row data, for the notes grid
                ctx.dispatch(new OnSetSharedGridRowData({ reload: true, payload: response, gridUUID: payload.gridUUID }));
            })
        );
    }

    //** Example on how we could add a single jets to the grid */
    @Action(OnAddNewNote)
    onAddNewNote(ctx: StateContext<ExampleStateModel>, { payload }: OnAddNewNote) {
        ctx.dispatch(new OnSetSharedGridRowData({ payload: payload.newNote, gridUUID: payload.gridUUID }));
    }
}
